import { Box, Center, Flex, IconButton, Image, Text } from "@chakra-ui/react";
import { faCaretLeft, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import sideBardata from "./SidebarData";

const SidebarDrawer = () => {
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    let activePath = location.pathname;
    let match = activePath.split("/").slice(0, 3).join("/");

    let pathIndex = sideBardata.findIndex((data) => data.path === match);
    setActiveIndex(pathIndex);
  }, [location]);

  return (
    <Box
      sx={{
        height: "100%",
        width: "max-content",
        minWidth: "80px",
        bg: "#213C5C",
        position: "relative",
        borderRadius: "0px 20px 0px 0px",
      }}
    >
      <Center pt={6}>
        <Image src="/images/logo_small.png" />
      </Center>
      <Box mx="4" mt={12} sx={{ bg: "#ffffff", opacity: "0.2" }}>
        <hr />
      </Box>

      {sideBardata.map((data, i) => (
        <Link key={`sideBardata${i}`} to={data.path}>
          <Flex
            mt={4}
            sx={{ height: "45px", width: "100%", cursor: "pointer" }}
          >
            <Box
              sx={{
                bg: activeIndex === i ? "#00A2E7" : null,
                borderRadius: "0 8px 8px 0",
                height: "100%",
                width: "6px",
              }}
            ></Box>

            <Center px={8} pr={expanded ? 16 : 8}>
              {/* <Icon viewBox="0 0 200 200" color="green"> */}

              <Flex>
                <svg
                  width="20"
                  height="18"
                  viewBox="0 0 20 18"
                  fill={activeIndex === i ? "#00A2E7" : "#B2B9BE"}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {data.icon}
                </svg>
                {expanded && (
                  <Text
                    sx={{ color: activeIndex === i ? "#00A2E7" : "#FFFFFF" }}
                    ml={4}
                  >
                    {data.title}
                  </Text>
                )}
              </Flex>
            </Center>
          </Flex>
        </Link>
      ))}

      <Box
        sx={{
          position: "absolute",
          top: "70px",
          zIndex: 10,
          right: "-18px",
        }}
      >
        <IconButton
          bg="#213C5C"
          height="55px"
          colorScheme="blue"
          aria-label="Search database"
          onClick={() => setExpanded(!expanded)}
          icon={
            expanded ? (
              <FontAwesomeIcon size="lg" icon={faCaretLeft} />
            ) : (
              <FontAwesomeIcon size="lg" icon={faCaretRight} />
            )
          }
        />
      </Box>
    </Box>
  );
};

export default SidebarDrawer;
